var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49988 8.66665V7.58332C6.49988 3.99347 9.41003 1.08332 12.9999 1.08332C16.5897 1.08332 19.4999 3.99347 19.4999 7.58332V8.66665H21.6665C22.2649 8.66665 22.7499 9.15168 22.7499 9.74999V22.75C22.7499 23.3483 22.2649 23.8333 21.6665 23.8333H4.33321C3.73491 23.8333 3.24988 23.3483 3.24988 22.75V9.74999C3.24988 9.15168 3.73491 8.66665 4.33321 8.66665H6.49988ZM20.5832 10.8333H5.41654V21.6667H20.5832V10.8333ZM11.9165 17.0434C11.2689 16.6688 10.8332 15.9686 10.8332 15.1667C10.8332 13.97 11.8032 13 12.9999 13C14.1965 13 15.1665 13.97 15.1665 15.1667C15.1665 15.9686 14.7308 16.6688 14.0832 17.0434V19.5H11.9165V17.0434ZM8.66654 8.66665H17.3332V7.58332C17.3332 5.19009 15.3931 3.24999 12.9999 3.24999C10.6066 3.24999 8.66654 5.19009 8.66654 7.58332V8.66665Z",
    fill: "#7D7CA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordLogo);
export default __webpack_public_path__ + "static/media/PasswordLogo.d585668f67e9fc0991515ce80213043f.svg";
export { ForwardRef as ReactComponent };